import { Badge, type BadgeTone } from './badge'
import type { InvoiceStatus } from '@/types/invoice'

const CONFIG: Record<string, { label: string; tone: BadgeTone }> = {
  PENDING: { label: 'Pendente', tone: 'warning' },
  PARTIAL: { label: 'Parcial', tone: 'info' },
  PAID: { label: 'Pago', tone: 'success' },
  OVERDUE: { label: 'Vencida', tone: 'danger' },
}

interface InvoiceStatusBadgeProps {
  readonly status: InvoiceStatus
  readonly isOverdue?: boolean
}

export function InvoiceStatusBadge({ status, isOverdue }: InvoiceStatusBadgeProps) {
  const key = isOverdue && status === 'PENDING' ? 'OVERDUE' : status
  const config = CONFIG[key] ?? CONFIG['PENDING']
  return <Badge tone={config.tone}>{config.label}</Badge>
}
